import routes from '../../../app/config/routes';

const flattenRoutes = rts => [
  ...rts,
  ...rts.reduce(
    (total, curr) => (curr.routes ? total.concat(flattenRoutes(curr.routes)) : total),
    []
  ),
];

let layoutRoutes;
export const getLayoutRoutes = () => {
  if (!layoutRoutes) {
    layoutRoutes = [...flattenRoutes(routes).map(route => route.path)];
  }
  return layoutRoutes;
};
